import { c as _c } from "react/compiler-runtime";
import { PartnerHospitalDoctor } from '@/entities/hospital/api/types';
import { Icon, Typography } from '@/shared/ui/atoms';
import { hasDoctorCareers } from '@/widgets/hospital/lib/doctorCareers';
interface DoctorProfileProps {
  doctor: PartnerHospitalDoctor;
}
const DoctorProfile = t0 => {
  const $ = _c(14);
  const {
    doctor
  } = t0;
  const {
    specialtyKeywords,
    careers,
    majorTreatments
  } = doctor;
  let t1;
  if ($[0] !== majorTreatments) {
    t1 = Array.isArray(majorTreatments) ? majorTreatments : [];
    $[0] = majorTreatments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const treatmentTags = t1;
  let t2;
  if ($[2] !== specialtyKeywords) {
    t2 = specialtyKeywords && <Typography size={13} className="pt-0.5 flex items-center gap-0.5 text-gray-600 -tracking-[0.5px]"><Icon src="/icons/medal.png" alt={"\uACBD\uB825"} width={16} height={16} />{specialtyKeywords}</Typography>;
    $[2] = specialtyKeywords;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== careers) {
    t3 = hasDoctorCareers(careers) && <Typography size={13} className="flex items-center gap-0.5 text-gray-600"><Icon src="/icons/check-mark.png" alt={"\uACBD\uB825"} width={16} height={16} />{careers}년</Typography>;
    $[4] = careers;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex items-center gap-2">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== treatmentTags) {
    t5 = treatmentTags.length > 0 && <div className="flex items-center gap-1">{treatmentTags.map(_temp)}</div>;
    $[9] = treatmentTags;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <div className="flex flex-col gap-1.5">{t4}{t5}</div>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export default DoctorProfile;
function _temp(item, index) {
  return <Typography key={`doctor-major-treatment-${index}`} size={10} lineHeight={13} className="py-1 px-1.5 rounded-full bg-gray-100 text-gray-600 font-medium">{item}</Typography>;
}